/**
 * Extends AimsMap.AccumulatingDynamicLayerFeatureSelector to filter feature selections based on
 * the `isSelectable` property of the site. `ReferenceSitesHashModel` is used to easily find the
 * corresponding site.
 */

import {
  AccumulatingDynamicLayerFeatureSelector
} from 'aims-map';

export default class SelectableSitesFilteringFeatureSelector extends AccumulatingDynamicLayerFeatureSelector {

  constructor(olMap, vectorSource, listeners, featureSelectionsModel, referenceSitesHashModel) {

    super(olMap, vectorSource, listeners, featureSelectionsModel);
    this._referenceSitesHashModel = referenceSitesHashModel;

  }

  /**
   * Override test to ensure the selected site is selectable.
   */
  _canSelect(id) {
    const referenceSite = this._referenceSitesHashModel.getData()[id];
    return referenceSite && referenceSite.isSelectable;
  }

}



// WEBPACK FOOTER //
// ./src/app/map/selectable-sites-filtering-feature-selector.js